import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";
import { PermissionsGroup } from "@robe/core-types";

export type PermissionsGroups = Array<PermissionsGroup>;

/** This may still return separate write boolean, this boolean is considered deprecated, should not be used and will be removed in future */
export const getLoggedUserPermissions = (core: XcoreCore): BaseApiRequest<PermissionsGroups> =>
  core.fetch("/api/groups/permissions").then((res) => res.json());
